import { render, staticRenderFns } from "./commonButton.vue?vue&type=template&id=2520ea76&scoped=true"
import script from "./commonButton.vue?vue&type=script&lang=js"
export * from "./commonButton.vue?vue&type=script&lang=js"
import style0 from "./commonButton.vue?vue&type=style&index=0&id=2520ea76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2520ea76",
  null
  
)

export default component.exports